export default __webpack_public_path__ + "static/media/cp_geo_sl.367f5c71.svg";